define('ordersUnpaidTableView',[
  'module',
  'ordersListView',
  'ordersUnpaidFiltersView'
], function (
  Module,
  OrdersListView,
  FiltersView
) {
  'use strict';

  Module.exports = OrdersListView.extend({
    className: 'unpaid-orders-table-view ' + OrdersListView.prototype.className,
    filtersViewClass: FiltersView,

    // Aging bucket picked on the totals tiles ('' = all of them)
    agingBucket: '',

    setAgingBucket: function(bucket) {
      this.agingBucket = bucket;
      this.footerView.setCurrentPage(1);
      this.bodyView.fetch();
      this.footerView.fetch();
    },

    getFiltersParams: function() {
      var params = OrdersListView.prototype.getFiltersParams.apply(this, arguments);
      // The whole screen is scoped to unpaid orders sitting in an "order due" status
      params.payedByCustomer = 'false';
      params.orderDue = 'true';
      params.excludedStatuses = 'CANCELLED,DECLINED';
      if(this.agingBucket)
        params.agingBucket = this.agingBucket;
      return params;
    }
  });
});

